import React, { useState } from "react";
import { exportUserReportApi } from "../../../../apis/userApis";

interface ExportReportModalProps {
  userId: string;
  userName: string;
  onClose: () => void;
}

const ExportReportModal: React.FC<ExportReportModalProps> = ({
  userId,
  userName,
  onClose,
}) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const canDownload = Boolean(startDate && endDate);

  const handleDownload = async () => {
    if (!canDownload) return;

    try {
      setLoading(true);
      setError("");

      const file = await exportUserReportApi({
        startDate,
        endDate,
        userId,
      });
      const url = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      const safeUserName = userName.trim().replace(/\s+/g, "-");
      link.download = `${safeUserName}-report-${startDate}-to-${endDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      onClose();
    } catch {
      setError("Unable to download the report. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="export-modal-overlay" role="dialog" aria-modal="true">
      <div className="export-modal-content">
        <h2>Export Report</h2>
        <div className="export-date-fields">
          <label>
            Start date
            <input
              type="date"
              value={startDate}
              max={endDate || undefined}
              onChange={(event) => setStartDate(event.target.value)}
            />
          </label>
          <label>
            End date
            <input
              type="date"
              value={endDate}
              min={startDate || undefined}
              onChange={(event) => setEndDate(event.target.value)}
            />
          </label>
        </div>
        {error && <p className="export-modal-error">{error}</p>}
        <div className="export-modal-actions">
          <button type="button" className="export-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="export-download-btn"
            disabled={!canDownload || loading}
            onClick={handleDownload}
          >
            {loading ? "Downloading..." : "Submit Download"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportReportModal;
